import {
    Typography, Button, FormControl, TextField, FormHelperText, InputLabel, Select, MenuItem
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import styles from '../dashboardStyles'
import datePickerPopper from './date.picker.popper.css'

import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import SearchIcon from '@mui/icons-material/Search'
// importing Icon - 23-07-24 - Dev Srini
import ClearIcon from '@mui/icons-material/Clear';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'


const CallDescription = ({
    callDescription,
    callDescriptionError,
    callDomain,
    callDomainError,
    callStatus,
    classes,
    comment,
    commentsError,
    dateError,
    dispatch,
    handleCallDescription,
    handleCallDomain,
    handleCallStatus,
    handleComment,
    handleDateChange,
    handlePendingBy,
    pendingBy,
    pendingByError,
    selectDate,
    showDomain,
    statusError,
    submitCallerInfo,
    isCallHangUp,
    tagPreviousIssue,
    inBound,
    clientId // srini - 28/11/24
}) => {

    

    const handleCloseDomain = () => {
        dispatch({
            type: 'SET_SHOW_DOMAIN',
            payload: false
        })

        dispatch({
            type: 'SET_CALL_DOMAIN',
            payload: ''
        })
    }

    const handlePreviousIssue = (e) => {
        dispatch({
            type: 'SET_TAG_PENDING_ISSUE',
            payload: e.target.value
        })

        if(e.target.value.length < 1){
            dispatch({
                type: 'SET_CALL_HISTORY_CHAT',
                payload: []
            })
        }
    }
    // reset value - 23-07-24 - Dev Srini
    const handlePreviousIssueReset = (e) => {
        dispatch({
            type: 'SET_TAG_PENDING_ISSUE',
            payload: ""
        })

        dispatch({
            type: 'SET_CALL_HISTORY_CHAT',
            payload: []
        })
    }
    const handleShowDomain = () => {
        dispatch({
            type: 'SET_SHOW_DOMAIN',
            payload: true
        })
    }

    const inBoundCallDisposition =  [
        { value: "Pending with me", label: "Pending with me", action: handleCloseDomain },
        { value: "Pending with others", label: "Pending with others", action: handleCloseDomain },
        { value: "Closed", label: "Closed", action: handleCloseDomain },
        { value: "Transfer", label: "Transfer", action: handleShowDomain }
    ]
    const outBoundCallDisposition =  [
        { value: "Pending with me", label: "Pending with me", action: handleCloseDomain },
        { value: "Pending with others", label: "Pending with others", action: handleCloseDomain },
        { value: "Closed", label: "Closed", action: handleCloseDomain },
        { value: "Transfer", label: "Transfer", action: handleShowDomain }
    ]

    const menuItems = inBound === 'incoming' ? inBoundCallDisposition : outBoundCallDisposition

    return (
        <div style={{ flex: '55%' }}>

            <Typography className={classes.layout2text}>Please fill bellow form with caller details
                {clientId && `- Client ID  ${clientId}` }
            </Typography>

            <div
                style={{
                    width: '521px',
                    height: '1px',
                    flexShrink: 0,
                    borderRadius: '4px',
                    background: '#000',
                    marginTop: '15px',
                    marginLeft: '75px'
                }}
            ></div>

            <div style={{ display: 'flex' }}>

                <div style={{ flex: '35%' }}>

                    <div style={{ marginLeft: '10px', marginTop: '10px' }}>
                        <Typography
                            className={classes.formLabel}
                            style={{ margin: '5px', color: callDescriptionError ? 'red' : '#999' }}
                        >
                            Call description
                        </Typography>
                        <FormControl className={`${classes.selectlayout2} ${classes.focused}`} >
                            <TextField
                                variant="filled"
                                id="call-field" // srini - 12/12/24
                                InputProps={{
                                    style: {
                                        width: '350px',
                                        height: '92px ',
                                        backgroundColor: '#0B1420',
                                        flexShrink: 0,
                                        color: '#999',
                                        fontFamily: 'cardiuma-regular !important',
                                        fontSize: '12px !important',
                                        fontStyle: 'normal',
                                        fontWeight: '400 !important',
                                        lineHeight: '20px',
                                        caretColor: 'white',
                                        paddingTop: '0px',
                                    },
                                    inputProps: { autoComplete: 'off' } // srini - 14/11/24
                                }} 
                                multiline
                                value={callDescription}
                                onChange={handleCallDescription}
                                autoComplete="off" // srini - 14/11/24
                            />
                        </FormControl>
                    </div>


                    <div style={{ marginLeft: '10px' }}>
                        <Typography
                            className={classes.formLabel}
                            style={{ margin: '2px', color: commentsError ? 'red' : '#999' }}
                        >
                            Comments
                        </Typography>
                        <FormControl className={classes.focused}>
                            <TextField
                                variant="filled"
                                id="comments-field" // srini - 12/12/24
                                InputProps={{
                                    style: {
                                        width: '350px',
                                        height: '92px ',
                                        backgroundColor: '#0B1420',
                                        flexShrink: 0,
                                        color: '#999',
                                        fontFamily: 'cardiuma-regular !important',
                                        fontSize: '12px !important',
                                        fontStyle: 'normal',
                                        fontWeight: '400 !important',
                                        lineHeight: '20px',
                                        caretColor: 'white',
                                        paddingTop: '0px',
                                    },
                                    inputProps: { autoComplete: 'off' } // srini - 14/11/24
                                }}
                                multiline
                                value={comment}
                                onChange={handleComment}
                                autoComplete='off' // srini - 14/11/24
                            />
                        </FormControl>
                    </div>

                    <div style={{ marginLeft: '10px', }}>
                        {/* if required txt + 25/08/24 - Dev Srini */}
                        <Typography
                            className={classes.formLabel}
                            style={{ margin: '2px'}}
                        >Tag Previous issue <span>(if required)</span></Typography>

                        <FormControl className={`${classes.selectlayout2} ${classes.focused}`}>

                            <TextField
                                id="issue-field" // srini - 12/12/24
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton style={{ color: 'white' }}>
                                                {/* Displaying cancel icon - 23-07-24 - Dev Srini */}
                                                {tagPreviousIssue.length > 0 ? <ClearIcon onClick={() => handlePreviousIssueReset()} /> : <SearchIcon />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    style: {
                                        width: '350px ',
                                        height: '52px ',
                                        backgroundColor: '#0B1420 ',
                                        flexShrink: 0,
                                        color: '#999',
                                        fontFamily: 'cardiuma-regular ! important',
                                        fontSize: '12px ! important',
                                        fontStyle: 'normal',
                                        fontWeight: '400  ! important',
                                        lineHeight: '20px',
                                        marginLeft: '10px'
                                    },
                                }}
                                value={tagPreviousIssue}
                                onChange={handlePreviousIssue}
                            />
                        </FormControl>
                    </div>
                </div>

                <div style={{ flex: '20%' }}>

                    <div style={{ marginTop: '35px' }}>
                        <FormControl className={`${classes.selectlayout2} ${classes.focused}`}>

                            <InputLabel
                                id="demo-simple-select-label"
                                className={classes.callhistoryrecords1}
                                style={{
                                    color: statusError ? 'red' : '#999',
                                    marginLeft: '5px',

                                }}
                                shrink={!!callStatus && callStatus.trim() !== ''}
                            >Select call disposition</InputLabel>

                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={callStatus}
                                onChange={handleCallStatus}
                                // disabled={callStatus == "Transfer" && true}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            backgroundColor: '#131E2E',
                                            marginTop: '10px'
                                        },
                                    },
                                }}

                                renderValue={(selectedValue) => (
                                    <span
                                        className={classes.inputtext}
                                        style={{ marginLeft: '8px' }}
                                    >{selectedValue}</span>
                                )}
                            >
                                {/* <MenuItem value="Pending with me" className={classes.inputtext} onClick={handleCloseDomain}>Pending with me</MenuItem>
                                <MenuItem value="Pending with others" className={classes.inputtext} onClick={handleCloseDomain} >Pending with others</MenuItem>
                                <MenuItem value="Closed" className={classes.inputtext} onClick={handleCloseDomain} >Closed</MenuItem>
                                <MenuItem value="Transfer" className={classes.inputtext} onClick={handleShowDomain}>Transfer</MenuItem>  */}

                                {menuItems.map((item, i) => (
                                    <MenuItem
                                        key={i}
                                        value={item.value}
                                        className={classes.inputtext}
                                        onClick={item.action}
                                    >
                                        {item.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>

                    {showDomain ?
                        <>
                            <div style={{ marginTop: '10px' }}>
                                <Typography 
                                    className={classes.formLabel} 
                                    style={{ marginLeft: '7px', color: callDomainError ? 'red' : '#999' }} 
                                >Select Domain</Typography>
                                <FormControl className={`${classes.selectlayout2} ${classes.focused}`}>
                                    <TextField
                                        id="domain-field" // srini - 12/12/24
                                        InputProps={{
                                            style: {
                                                width: '265px ',
                                                height: '45px ',
                                                backgroundColor: '#0B1420 ',
                                                flexShrink: 0,
                                                color: '#999',
                                                fontFamily: 'cardiuma-regular',
                                                fontSize: '12px',
                                                fontStyle: 'normal',
                                                fontWeight: '400',
                                                lineHeight: '20px',
                                                paddingLeft: '10px',
                                            }
                                        }}
                                        value={callDomain}
                                        onChange={e => handleCallDomain(e)}
                                    />
                                </FormControl>
                            </div>

                            <div style={{ display: 'flex', margin: '125px 0px 0px 135px', padding: '25px' }}>
                                <Button
                                    className={isCallHangUp ? classes.submitbuttonlayout_dis : classes.submitbuttonlayout}
                                    disabled={isCallHangUp}
                                    onClick={submitCallerInfo}
                                >
                                    <span
                                        className={classes.submitbuttontext}
                                        style={{ textTransform: 'none' }}

                                    > Submit </span>
                                </Button>
                            </div>
                        </>
                        :
                        <>
                            {callStatus !== "Closed" && callStatus !== "Pending with me" && <div className={`${classes.selectlayout1} ${classes.focused1}`}>
                                <Typography className={classes.formLabel} style={{ margin: '2px 0px 3px 10px', color: pendingByError ? 'red' : '#999' }}>Pending From</Typography>
                                <FormControl>
                                    <TextField
                                        id="pending-by-field" // srini - 12/12/24
                                        InputProps={{
                                            style: {
                                                width: '270px ',
                                                backgroundColor: '#0B1420 ',
                                                flexShrink: 0,
                                                color: '#999',
                                                fontFamily: 'cardiuma-regular',
                                                fontSize: '12px',
                                                fontStyle: 'normal',
                                                fontWeight: '400',
                                                lineHeight: '20px',
                                                paddingLeft: '10px'
                                            },
                                            inputProps: { autoComplete: 'off' }
                                        }}
                                        value={pendingBy}
                                        onChange={handlePendingBy}
                                        autoComplete='off'
                                    />
                                </FormControl>
                            </div>}

                            {callStatus !== "Closed" && <div style={{ marginTop: '10px' }} className={`${classes.selectlayout1} ${classes.focused1}`} >
                                <LocalizationProvider dateAdapter={AdapterDayjs} >
                                    <DemoContainer components={['DateTimePicker']} >
                                        <style >
                                            {
                                                
                                                `
                                                .MuiFormLabel-root, .MuiFormLabel-root.Mui-focused {
                                                color: ${dateError ? 'red' : '#999'};
                                                font-size: 12px;
                                                }
                                                .MuiInputBase-input::placeholder {
                                                color: #999;
                                                }
                                                .MuiInputBase-input {
                                                color:  #999 !important; 

                                                }
                                                .MuiIconButton-root .MuiSvgIcon-root {
                                                fill: white !important; 
                                                }
                                                .MuiOutlinedInput-notchedOutline {
                                                border: none !important; 
                                                }

                                                .MuiIconButton-root.MuiDateTimePicker-iconButton {
                                                margin-right: 94px !important; 
                                                }
                                                .custom-datetime-picker {
                                                width: 80px ! important; 
                                                height: 120px ! important; 
                                                }
                                                .MuiIconButton-root.MuiDateTimePicker-iconButton {
                                                margin-right: 194px ; 
                                                }`
                                            },
                                        </style>
                                        <div className={classes.datePickerPopper}>

                                        <DateTimePicker
                                            id="date-field" // srini - 12/12/24
                                            label="Follow-up Date and Time"
                                            value={selectDate}
                                            onChange={handleDateChange}
                                            format="YYYY-MM-DD HH:mm A"
                                            disablePast
                                            slotProps={{
                                                textField: {
                                                    readOnly: true,
                                                },
                                            }}
                                        />
                                        </div>
                                    </DemoContainer>
                                </LocalizationProvider>
                            </div>}

                            <div style={{ display: 'flex', margin: callStatus !== "Closed" ? '65px 0px 0px 135px' : '198px 0px 0px 135px', padding: '25px' }}>
                                <Button
                                    className={isCallHangUp ? classes.submitbuttonlayout_dis : classes.submitbuttonlayout}
                                    disabled={isCallHangUp}
                                    onClick={submitCallerInfo}
                                >
                                    <span
                                        className={classes.submitbuttontext}
                                        style={{ textTransform: 'none' }}

                                    > Submit </span>
                                </Button>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

export default withStyles(styles)(CallDescription)